<template>
  <div :id="id" class="modal-popup top">
    <div class="modal-popup-content">
      <img src="@/assets/images/cms-mkt/loading.gif" />
      <p v-html="$t('cmsLang.loadingPopupMessage')"></p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalPopupLoading",
  props: {
    id: {
      default: "modal_popup_loading_cms",
      type: String,
    },
  },
};
</script>
<style scoped src="@/assets/styles/mkt-cms.css"></style>
<style lang="scss">
.top {
  z-index: 90000 !important;
}
</style>